import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "../../actions"
import fieldStatus from "../../helpers/fieldStatus"
import submitData from "../../helpers/submitData"
import { Formik, Field, Form } from "formik"
import fields from "models/lotType"
import * as Yup from "yup"
import { Redirect } from "react-router-dom"
import { toast } from "react-toastify"
import _ from "lodash"
import Title from "../general/title"
import ReactSelect from "components/ReactSelect"
import TextArea from "components/TextArea"
import NumberField from "components/NumberField"
import ColorPicker from "components/ColorPicker"
import settings from "settings"

class AddLotType extends Component {
	constructor(props) {
		super(props)
		this.state = {
			ready: false,
			modal: false,
			fields: fields,
		}
	}

	validation = () => {
		return Yup.object().shape({
			name: Yup.string().required("Required"),
			classification: Yup.string().required("Required"),
			property: Yup.number().required("Required"),
			size: Yup.number().required("Required"),
			short_desc: Yup.string().notRequired(),
			long_desc: Yup.string().notRequired(),
		})
	}

	submitClasses = f => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	render() {
		if (!this.props.payloadStatus) {
			return ""
		} else if (this.state.redirect) {
			return <Redirect to={this.state.redirectPath} />
		} else {
			return (
				<div>
					<Title title="Add Lot Type" showDate={false} />
					<div className="content">
						<h3 />
						<Formik
							enableReinitialize
							initialValues={this.state.fields}
							validationSchema={this.validation}
							validateOnMount={true}
							onSubmit={(values) => {
								this.props.loadingStatus(true)
								if (!values.repetition_rules) delete values.repetition_rules
								submitData("inputLotType", values).then((data) => {
									this.props.loadingStatus(false)
									toast.success(data.message)
									this.setState(
										{
											redirect: true,
											redirectPath: data.redirect,
										},
										() => {
											this.props.getPayload()
										}
									)
								})
							}}>
							{(f) => (
								<div>
									<Form>
										{console.log(f)}
										<ul className="form__list">
											<li className={fieldStatus("name", f)}>
												<label htmlFor="name">
													Name <sup>*</sup>
												</label>
												{f.errors.name && f.touched.name && (
													<div className="form__message">{f.errors.name}</div>
												)}
												<Field name="name" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("marketing_name", f)}>
												<label htmlFor="marketing_name">Marketing Name</label>
												{f.errors.marketing_name && f.touched.marketing_name && (
													<div className="form__message">{f.errors.marketing_name}</div>
												)}
												<Field name="marketing_name" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("property", f)}>
												<label htmlFor="property">
													Property <sup>*</sup>
												</label>
												{f.errors.property && f.touched.property && (
													<div className="form__message">{f.errors.property}</div>
												)}
												<ReactSelect
													name={`property`}
													options={_.map(this.props.payload.public.properties, (v) => {
														return { label: v.name, value: v.id }
													})}
													value={f.values.property}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("size", f)}>
												<label htmlFor="size">
													Lot Size <sup>*</sup>
												</label>
												{f.errors.size && f.touched.size && (
													<div className="form__message">{f.errors.size}</div>
												)}
												<ReactSelect
													name={`size`}
													options={_.map(this.props.payload.public.lot_sizes, (v) => {
														return { label: v.name, value: v.id }
													})}
													value={f.values.size}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("classification", f)}>
												<label htmlFor="classification">
													Classification <sup>*</sup>
												</label>
												{f.errors.classification && f.touched.classification && (
													<div className="form__message">{f.errors.classification}</div>
												)}
												<ReactSelect
													name={`classification`}
													options={[
														{ value: "Production", label: "Production" },
														{ value: "Custom", label: "Custom" },
														{ value: "Specialty", label: "Specialty" },
													]}
													value={f.values.classification}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("color", f)}>
												<label htmlFor="color">
													Color{" "}
													<span className="small">
														<i
															className={`fas fa-info-circle`}
															style={{ marginRight: 5 }}
														/>
														Hex Code
													</span>
												</label>
												{f.errors.color && f.touched.color && (
													<div className="form__message">{f.errors.color}</div>
												)}
												<Field name="color" type="text" className="form__input" />
												<ColorPicker
													name={`color`}
													value={f.values.color}
													onChange={(v) => f.setFieldValue("color", v)}
												/>
											</li>
											<li className={fieldStatus("sqft_min", f)}>
												<label htmlFor="sqft_min">Sqft Min</label>
												{f.errors.sqft_min && f.touched.sqft_min && (
													<div className="form__message">{f.errors.sqft_min}</div>
												)}
												<NumberField
													name={"sqft_min"}
													value={f.values.sqft_min}
													//format="+1 (###) ###-####"
													type="text"
													className="form__input"
													onChange={(old, v) => f.setFieldValue("sqft_min", v)}
													onBlur={() => {}}
												/>
											</li>
											<li className={fieldStatus("sqft_max", f)}>
												<label htmlFor="sqft_max">Sqft Max</label>
												{f.errors.sqft_max && f.touched.sqft_max && (
													<div className="form__message">{f.errors.sqft_max}</div>
												)}
												<NumberField
													name={"sqft_max"}
													value={f.values.sqft_max}
													//format="+1 (###) ###-####"
													type="text"
													className="form__input"
													onChange={(old, v) => f.setFieldValue("sqft_max", v)}
													onBlur={() => {}}
												/>
											</li>
											{settings.arc ? (
												<li className={fieldStatus("repetition", f)}>
													<label htmlFor="repetition">Repetition</label>
													{f.errors.repetition && f.touched.repetition && (
														<div className="form__message">{f.errors.repetition}</div>
													)}
													<NumberField
														name={"repetition"}
														value={f.values.repetition}
														type="text"
														className="form__input"
														onChange={(old, v) => f.setFieldValue("repetition", v)}
														onBlur={() => {}}
													/>
												</li>
											) : null}
											<li className={fieldStatus("short_desc", f)}>
												<label htmlFor="short_desc">Short Description</label>
												{f.errors.short_desc && f.touched.short_desc && (
													<div className="form__message">{f.errors.short_desc}</div>
												)}
												<Field name="short_desc" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("long_desc", f)}>
												<label htmlFor="long_desc">Long Description</label>
												{f.errors.long_desc && f.touched.long_desc && (
													<div className="form__message">{f.errors.long_desc}</div>
												)}
												<TextArea
													name="long_desc"
													className="form__textarea"
													value={f.values.long_desc}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.long_desc}
													error={f.errors.long_desc}
												/>
											</li>
										</ul>
										<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
									</Form>
								</div>
							)}
						</Formik>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(AddLotType)
